import { render, staticRenderFns } from "./CommentCard.vue?vue&type=template&id=e8680ea8&scoped=true&"
import script from "./CommentCard.vue?vue&type=script&lang=js&"
export * from "./CommentCard.vue?vue&type=script&lang=js&"
import style0 from "./CommentCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CommentCard.vue?vue&type=style&index=1&id=e8680ea8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8680ea8",
  null
  
)

export default component.exports